import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ModalDirective } from 'ngx-bootstrap';

import { Column, DatatableButton, User } from 'app/models';
import { UserService } from 'app/services';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
  providers: []
})
export class AdminUsersComponent implements OnInit {
  @ViewChild('deleteUserModal') deleteUserModal: ModalDirective;

  public columns: Column[] = [
    { property: 'name', label: 'USERS.TABLE.NAME', type: 'string' },
    { property: 'email', label: 'USERS.TABLE.EMAIL', type: 'string' },
    { property: 'active', label: 'USERS.TABLE.ACTIVE', type: 'string' }
  ];

  public buttons: DatatableButton[] = [
    {
      id: 'trash',
      action: this.prepareRemoveUser.bind(this),
      showIf: data => true,
      icon: 'trash',
      classes: 'btn btn-primary'
    }
  ];

  public users: User[] = [];
  public userToRemove: User;

  constructor(private readonly router: Router, private readonly userService: UserService) {}

  public ngOnInit() {
    this.getUsers();
  }

  prepareRemoveUser(user: User) {
    console.log(user);
    this.userToRemove = user;
    this.deleteUserModal.show();
  }
  stopRemoveUser() {
    this.userToRemove = null;
    this.deleteUserModal.hide();
  }

  removeUser() {
    this.userService.deleteUser(this.userToRemove.id).subscribe(removedUser => this.getUsers());
  }

  private getUsers() {
    this.userService.getUsers().subscribe(users => {
      this.users = users;
      this.stopRemoveUser();
    });
  }

  newUser() {
    this.router.navigate(['/admin/users/new']);
  }

  goToUserDetailPage(user: User) {
    this.router.navigate([`/admin/users/detail/${user.id}`]);
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/admin-users.component.ts